/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Pdf_Docx_ExportInputs */

const en_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX export`)
};

const de_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX-Export`)
};

const fr_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export PDF + DOCX`)
};

const es_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación PDF + DOCX`)
};

const it_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione PDF + DOCX`)
};

const nl_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX-export`)
};

const pl_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksport PDF + DOCX`)
};

const fi_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX-vienti`)
};

const da_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX-eksport`)
};

const sv_pricing_feature_pdf_docx_export = /** @type {(inputs: Pricing_Feature_Pdf_Docx_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX-export`)
};

/**
* | output |
* | --- |
* | "PDF + DOCX export" |
*
* @param {Pricing_Feature_Pdf_Docx_ExportInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_pdf_docx_export = /** @type {((inputs?: Pricing_Feature_Pdf_Docx_ExportInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Pdf_Docx_ExportInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_pdf_docx_export(inputs)
	if (locale === "fr") return fr_pricing_feature_pdf_docx_export(inputs)
	if (locale === "es") return es_pricing_feature_pdf_docx_export(inputs)
	if (locale === "it") return it_pricing_feature_pdf_docx_export(inputs)
	if (locale === "nl") return nl_pricing_feature_pdf_docx_export(inputs)
	if (locale === "pl") return pl_pricing_feature_pdf_docx_export(inputs)
	if (locale === "fi") return fi_pricing_feature_pdf_docx_export(inputs)
	if (locale === "da") return da_pricing_feature_pdf_docx_export(inputs)
	if (locale === "sv") return sv_pricing_feature_pdf_docx_export(inputs)
	return en_pricing_feature_pdf_docx_export(inputs)
});